import React from 'react';
import I18n from 'i18n-js';
import URLHelpers from '../shared/url_helpers';
import SanitizedRender from '@reverbdotcom/commons/dist/components/sanitized_render';
import { CoreBumpRecommendationListingCard } from '../../schemas/rql';
import { isCSPMatched } from './bump_helpers';

interface Props {
  listing: CoreBumpRecommendationListingCard.Fragment;
}

function DescriptionIsMatched(props: Props) {
  const descMatched = I18n.t('discovery.bumpModalV2.modal.description.promoteInPremiumSpotswCP', {
    tagOpen: '<strong>',
    tagClose: '</strong>',
    cspTitle: props.listing.csp?.title,
    linkOpen: `<a class="weight-bold" href="${URLHelpers.cspPath(props.listing.csp?.slug)}" target="_blank">`,
    linkClose: '</a>',
  });

  const buyBoxBody = I18n.t('discovery.bumpModalV2.modal.description.bumpModalBody', {
    tagOpen: '<strong>',
    tagClose: '</strong>',
  });

  return (
    <>
      <p className="mb-half">
        <SanitizedRender html={descMatched} />
      </p>
      <p className="mb-half">
        <SanitizedRender html={buyBoxBody} />
      </p>
    </>
  );
}

function DescriptionNotMatched() {
  const descUnmatched = I18n.t('discovery.bumpModalV2.modal.description.promoteInPremiumSpots', {
    tagOpen: '<strong>',
    tagClose: '</strong>',
  });

  const buyBoxBody = I18n.t('discovery.bumpModalV2.modal.description.bumpModalBody', {
    tagOpen: '<strong>',
    tagClose: '</strong>',
  });

  return (
    <>
      <p className="mb-half">
        <SanitizedRender html={descUnmatched} />
      </p>
      <p className="mb-half">
        <SanitizedRender html={buyBoxBody} />
      </p>
    </>
  );
}

function Description(props: Props) {
  const listingIsMatched = isCSPMatched(props.listing);

  if (listingIsMatched) {
    return <DescriptionIsMatched listing={props.listing} />;
  }

  return <DescriptionNotMatched />;
}

export function BumpDescription(props: Props) {
  const bumpPage = URLHelpers.cmsPagePath('bump');

  return (
    <div className="size-90">
      <Description listing={props.listing} />
      <p className="mb-0">
        <SanitizedRender
          html={
            I18n.t('discovery.bumpModalV2.modal.description.payIfSells', {
              linkOpen: `<a class="icon-r-external-link" target="_blank" href="${bumpPage}">`,
              linkClose: '</a>',
            })
          }
        />
      </p>
    </div>
  );
}
